import request from '@/utils/request';

const path = 'api/v1';

const productsList = data => request({
  url: `${path}/products`,
  method: 'Get',
  params: data,
});

const createProductPost = (data) => request({
    url: `${path}/products`,
    method: 'post',
    data
});

const rmProductDelete = (data) => request({
    url: `${path}/products`,
    method: 'delete',
    data
});

const updateProductPut = (data) => request({
    url: `${path}/products`,
    method: 'put',
    data
});


export {
  productsList,
  createProductPost,
  rmProductDelete,
  updateProductPut
};
